import React, { useState } from 'react';
import { Sidebar, BottomNav } from './components/Navigation';
import Dashboard from './views/Dashboard';
import Chores from './views/Chores';
import Maintenance from './views/Maintenance';
import Calendar from './views/Calendar';
import Settings from './views/Settings';
import HowItWorks from './views/HowItWorks';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard': return <Dashboard />;
      case 'chores': return <Chores />;
      case 'maintenance': return <Maintenance />;
      case 'calendar': return <Calendar />;
      case 'demo': return <HowItWorks />;
      case 'settings': return <Settings />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen w-full bg-slate-950 text-slate-200 overflow-hidden relative selection:bg-teal-500/30">
      {/* Background ambient glow */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-teal-900/20 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] bg-amber-900/10 blur-[120px] rounded-full pointer-events-none" />

      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <main className="flex-1 relative z-10 overflow-hidden">
        {renderContent()}
      </main>

      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default App;